import React from 'react';
import classNames from 'classnames';
import css from './styles.module.scss';
import { BoxProps } from '@material-ui/core/Box/Box';
import { Box, Typography } from '@material-ui/core';

type KeyDatesTableProps = BoxProps & {
    title: string;
    data?: { label: string; meta: string | JSX.Element }[];
};

export const KeyDatesTable: React.FC<KeyDatesTableProps> = ({ data, title, className }) => {
    return (
        <Box className={classNames(css.module, className)}>
            <Box className={css.title}>
                <Typography>{title}</Typography>
            </Box>
            {data?.length ? data.map((row, index) => (
                <Box className={css.row} key={index}>
                    <Box className={css.label}>{ row.label }</Box>
                    <Box className={css.meta}>{ row.meta }</Box>
                </Box>
            )) : (
                <Box className={css.row}>
                    <Typography>Nothing to show</Typography>
                </Box>
            )}
        </Box>
    );
};
